type AuthExpiredHandler = () => void;

const handlers = new Set<AuthExpiredHandler>();
let notifying = false;

export function onAuthExpired(handler: AuthExpiredHandler): () => void {
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}

export function notifyAuthExpired() {
  if (notifying) {
    return;
  }

  notifying = true;
  try {
    handlers.forEach((handler) => {
      try {
        handler();
      } catch (error) {
        console.error('Auth expiration handler failed', error);
      }
    });
  } finally {
    notifying = false;
  }
}
